export default "__VITE_ASSET__B90E1KWo__"